<!--
支出统计
-->
<template>
  <iframe  width="100%" style="border: 0px;" height="100%" :src="'//'+util.apiBasePath+url">

  </iframe>
</template>
<script>
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import util from '../../../../libs/util'
  export default {
    name: 'expenditure-data-char',
    components: {ScrollRightFrame},
    data() {
      return {
        util:util,
        noback:'',
        url:'/jpcp/project/statisticChar/expenditureIndexView',
      }
    },
    watch: {
      '$route':function(to, from) {
                  
        }
    },
    mounted(){   

    this.noback =this.$route.query.noback;
    const _than =this;
    window.goback =function(){
       util.routerBack(_than,"/");
    }
    window.tip =function(msg){
        _than.$notify.success({title: '成功', message: msg});
    }
    },
    methods: {

    }
  }
</script>
<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/project/expenditure-data-char.vue